'use strict';

module.exports = /* @ngInject */ function($resource, apiConfig) {

    return {
		error: function(msg) {
			growl(msg.data.error, 1);
		},
		isUniteActive: $resource(
					apiConfig.$get().apiUrl + '/unite/supplier/:supplier_group_id/uniteActive',
					{
						supplier_group_id:'@supplier_group_id'
                    }, {
                        query: {
                            isArray: false,
                        }
                    }
                ),
        getUniteAddresses: $resource(
            apiConfig.$get().apiUrl + '/unite/supplier/:supplier_group_id/companies',
            {
                supplier_group_id:'@supplier_group_id'
            }
        ),
        getUniteApiType : $resource(
            apiConfig.$get().apiUrl + '/unite/supplier/:supplier_group_id/unite-api-type',
            {
                supplier_group_id:'@supplier_group_id'
            }, {
                query: {
                    isArray: false,
                    transformResponse: function (data) {
                        return {
                            data: JSON.parse(data)
                        }
                    }
                }
            }
        )
	};

}
